import React from "react";
import { AimCircle as Icon } from '../../components/Svg'
import './styles.scss';
import Languages from "../../const/languages";

export default () => (
    <div className="our-cases__list">
        <div className="our-cases__item">
            <Icon className="our-cases__item-icon" />
    
            <div
                className="our-cases__item-text"
                dangerouslySetInnerHTML={{__html: Languages.keyProjects.info1}}
            />
        </div>

        <div className="our-cases__item">
            <Icon className="our-cases__item-icon" />

            <div
                className="our-cases__item-text"
                dangerouslySetInnerHTML={{__html: Languages.keyProjects.info2}}
            />
        </div>
    </div>
)
